import { DocumentType, CctDetailsFieldFullValue, Cct } from "../../__generated__/graphql";
import React, { useMemo } from "react";
import { getLocaleTag, useI18n } from "../../hooks/i18n-hooks";
import { StackNavigationProp } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";
import DocumentsList from "../document/DocumentsList";
import ListGroup from "../ListGroup";

type CctDetailsProps = {
    cct: Cct;
    cctDetails: CctDetailsFieldFullValue;
    navigation?: StackNavigationProp<RootStackParamList, "CctDetails">;
};

const CctDetails: React.FC<CctDetailsProps> = ({ cct, cctDetails }) => {
    const i18n = useI18n();
    const localeTag = getLocaleTag();

    const cctUrl = useMemo(() => {
        if (cct.cctUrl) {
            return cct.cctUrl;
        } else {
            return `https://www.tempservice.ch/tools/pdf/detail.php?cid=${cct.cctContractId}&vid=${cct.cctVersionId}&eid=${cct.cctEditionId}&lang=${localeTag}`;
        }
    }, [cct, localeTag]);

    return (
        <>
            <DocumentsList
                documents={[
                    {
                        id: "cct",
                        title: "CCT",
                        description: cct?.name || "",
                        icon: "__none__",
                        documentUrl: cctUrl,
                        documentMimeType: "application/pdf",
                        type: DocumentType.Other,
                        labels: [{ text: i18n.t("see_more"), mode: "miniCta" }],
                    },
                ]}
            />
            <ListGroup
                items={[
                    ...cctDetails.readableValues.map((v) => ({
                        key: v.question,
                        title: v.question,
                        description: v.answer,
                        value: v.answer,
                    })),
                ]}
            />
        </>
    );
};

export default CctDetails;
